<template>
  <div>
    <v-container fluid class="py-0">
      <v-row>
        <v-card flat color="transparent" class="mx-auto py-12 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("about.interview_page.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">INTERVIEW</v-card-subtitle>
        </v-card>
      </v-row>
      <v-row no-gutters class="text-center" align="start">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col>
          <v-card class="mb-4" flat tile color="transparent">
            <v-card-title :class='isMobile?"subtitle-1":"headline font-weight-regular text-no-wrap justify-center"' v-html="$t('about.interview_page.content')">{{ $t('about.interview_page.content') }}</v-card-title>
          </v-card>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-row justify="center">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <div >
          <v-row v-for="index in Math.floor(magazines.length/3)+1" :key='"row_"+index'>
              <v-card :width='imgWidth' v-for="(subMagazine) in magazines.slice((index-1)*3,index*3)" :key="subMagazine.mdate" class="ma-2" flat>
                <v-img src="../assets/company/c5-1.jpg"></v-img>
                <v-img :src=subMagazine.imageUrl></v-img>
                <v-row justify="center" :class='isMobile?"":"pb-2"'>
                  <div :style='isMobile?"":"min-height:90px"'>
                    <v-card-title :class='(isMobile?"title":"subtitle-1")+" text-center"'>{{ subMagazine.title }}</v-card-title>
                  </div>
                </v-row>
                <v-row justify="center">
                  <v-card-subtitle :class='(isMobile?"title":"subtitle-1")+" text-center pt-0"'>{{ subMagazine.mdate }}</v-card-subtitle>
                </v-row>
                <v-card-actions>
                  <v-row justify="center">
                      <v-btn :to='"/interview-magazine/"+subMagazine.id' depressed tile color="#90CAC5" class="white--text">{{ $t('service.detailBtn') }}</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
          </v-row>
        </div>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyInterview",
  components: {
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    magazines: [
      {"id":0, "imageUrl":require('../assets/company/c5202009.jpg'),"title":"及时把握生产进度和不良实绩 着手提供实绩管理系统","mdate":"2020年9月号"},
      {"id":1, "imageUrl":require('../assets/company/c5201909.jpg'),"title":"19年上半年销售额增长1.5倍 中国客户&深圳地区的开拓","mdate":"2019年9月号"},
      {"id":2, "imageUrl":require('../assets/company/c5201901.jpg'),"title":"从实绩看实力！","mdate":"2019年1月号"},
      {"id":3,"imageUrl":require('../assets/company/c5201812.jpg'),"title":"用技术手段来改善生产业务","mdate":"2018年12月号"},
      {"id":4,"imageUrl":require('../assets/company/c5201811.jpg'),"title":"从苏州大宇宙的实际事例中一探RPA的真实价值","mdate":"2018年11月号"},
      {"id":5,"imageUrl":require('../assets/company/c5201809.jpg'),"title":"不断扩充的十年","mdate":"2018年9月号"},
      {"id":6,"imageUrl":require('../assets/company/c5201704.jpg'),"title":"系统开发和外包服务的专门企业","mdate":"2017年4月号"},
    ],
    isMobile: false
  }),
  methods:{
  
  },
  computed: {
    imgWidth: function(){
      if(this.isMobile){
        return window.innerWidth;
      }else{
        return 250;
      }
    }
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
